<script lang="ts">
  import {mc} from '@/core';
  import {sd} from '@/da';
  import {connector$} from '@/streams/wallet-connect';
  import {connectMetaMaskWallet, connectWalletConnectWallets} from '@/streams/wallet-connect';
  import Spin from '@/widgets/Spin.svelte';
  import {trackConnectType} from '../track';
  import TransitionWrap from '../TransitionWrap.svelte';
  import {step$} from '../streams';
  import lang from '../DepositDrawer.lang';

  export let LG;
  let innerWidth = 1200;

  const wallets = {
    metaMask: 'metaMask',
    walletConnect: 'walletConnect',
  };

  let currentWallet: typeof wallets[keyof typeof wallets];
  let loading = false;

  $: ({address} = $connector$);
  $: watchConnectSuccess(address);
  $: showMetaMask = innerWidth >= 900;

  function watchConnectSuccess(address) {
    if (address) {
      step$.next('walletDeposit');
      trackConnectType();
    }
  }

  function connectWalletFun(wallet) {
    return async function connectWallet() {
      const $element_content = wallet === wallets.metaMask ? 'metamask' : 'walletconnect';
      sd.track('web_click', {$screen_name: 'choose_wallet', $element_content});
      if (loading) {
        return;
      }
      currentWallet = wallet;
      loading = true;
      try {
        if (wallet === wallets.metaMask) {
          await connectMetaMaskWallet({useCurrentChain: true});
        } else if (wallet === wallets.walletConnect) {
          await connectWalletConnectWallets();
        }
      } catch (error) {
        if (error?.type !== 'SKIP_STEP') {
          mc.send('toast', 'error', error);
        }
      } finally {
        loading = false;
      }
    };
  }
</script>

<style lang="scss">
  .item {
    padding: 16px 24px;
    &.disabled {
      cursor: not-allowed;
    }
    &:hover {
      background: #f4f7fe;
      .arrow-icon {
        color: var(--blue);
      }
    }
  }
  .icon-box {
    display: flex;
    justify-content: end;
    align-items: center;
    width: 26px;
    height: 26px;
  }
  :global(wcm-modal) {
    position: relative;
    z-index: 9999;
  }
</style>

<svelte:window bind:innerWidth />
<TransitionWrap>
  <div class="choose-wallet wp100">
    <h1 class="p0 T1 f32 b">{LG(lang.ChooseWallet)}</h1>
    <div class="list">
      <div class="item df aic mt32 cp br8 {showMetaMask ? 'df' : 'dn'}" class:disabled={loading} on:click={connectWalletFun(wallets.metaMask)}>
        <img src="https://img.phemex.com/v1/cef5dd17/transparent-metamask.svg" width="36" height="36" alt="metamask" srcset="" />
        <h3 class="ml16 p0 T1 f20 b f1">MetaMask</h3>
        <div class="icon-box">
          {#if loading && currentWallet === wallets.metaMask}
            <Spin style="position: relative; background: none;transform: scale(0.7);" />
          {:else}
            <i class="arrow-icon iconfont T1 f14 b">&#xe60b;</i>
          {/if}
        </div>
      </div>
      <div class="item df aic mt16 cp br8" class:disabled={loading} on:click={connectWalletFun(wallets.walletConnect)}>
        <img src="https://img.phemex.com/v1/b18891a8/wallet-connect.svg" width="36" height="36" alt="walletconnect" srcset="" />
        <h3 class="ml16 p0 T1 f20 b f1">WalletConnect</h3>
        <div class="icon-box">
          {#if loading && currentWallet === wallets.walletConnect}
            <Spin style="position: relative; background: none;transform: scale(0.7);" />
          {:else}
            <i class="arrow-icon iconfont T1 f14 b">&#xe60b;</i>
          {/if}
        </div>
      </div>
    </div>
  </div>
</TransitionWrap>
